'use client'

import { useMemo } from 'react'
import type { Column, DataTableFilterActions, FilterStrategy, FiltersState } from '../core/types'
import type { Locale } from '../lib/i18n'
import { ActiveFilters } from './active-filters'
import { FilterActions } from './filter-actions'
import { FilterSelector } from './filter-selector'

interface DataTableFilterProps<TData> {
  columns: Column<TData>[]
  filters: FiltersState
  actions: DataTableFilterActions
  strategy: FilterStrategy
  locale?: Locale
}

export function DataTableFilter<TData>({
  columns,
  filters,
  actions,
  strategy,
  locale = 'en',
}: DataTableFilterProps<TData>) {
  const moreFilterColumns = useMemo(
    () => columns.filter((col) => col.showInMoreFilters === true),
    [columns],
  )

  return (
    <>
      <ActiveFilters
        columns={columns}
        filters={filters}
        actions={actions}
        strategy={strategy}
        locale={locale}
      />
      <FilterSelector
        columns={moreFilterColumns}
        filters={filters}
        actions={actions}
        strategy={strategy}
        locale={locale}
      />
      <FilterActions hasFilters={filters.length > 0} actions={actions} locale={locale} />
    </>
  )
}
